const initialState =
{
    data: [],
    saving: false,
};

export default (state = initialState, action) => {

    switch(action.type) {

        case 'OLDTICKETS_LIST':
            return {
                ...state,
                data: action.payload
            }
            break;
            case 'PROSPECT_SAVE':
            return {
                ...state,
                saving: true
            }

        case 'PROSPECT_SAVE_SUCCESS':
            return {
                ...state,
                saving: false,
                data: [...state.data, action.payload]
            }

        case 'PROSPECT_UPDATE_SUCCESS':
            let newp = action.payload;
            return {
                ...state,
                saving: false,
                data: state.data.map((d, i) => { return (d.value == newp.value) ? newp : d })
            }
        break;

        case 'PROSPECT_SAVE_FAILURE':
            return {
                ...state,
                saving: false,
            }

        default:
            return state;
    }
    
};


// WEBPACK FOOTER //
// ./src/reducers/categorias.js